import { useLayoutEffect, useState } from 'react';
import { useWindowSize } from 'react-use';

export function useTouchScreen(): boolean {
  const [isTouchScreen, setIsTouchScreen] = useState(false);

  useLayoutEffect(() => {
    const detectTouchScreen = () => {
      return (
        'ontouchstart' in window ||
        (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ||
        navigator.maxTouchPoints > 0
      );
    };

    setIsTouchScreen(detectTouchScreen());
  }, []);

  return isTouchScreen;
}

type AspectRatio = 'landscape' | 'portrait';

interface AspectRatioReturn {
  aspectRatio: AspectRatio;
  isLandscape: boolean;
  isPortrait: boolean;
}

export const useAspectRatio = (): AspectRatioReturn => {
  const { width, height } = useWindowSize();
  const isLandscape = width > height;

  return {
    aspectRatio: isLandscape ? 'landscape' : 'portrait',
    isLandscape,
    isPortrait: !isLandscape,
  };
};
